import { Component, Input, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { AddDocumentTagComponent } from 'src/app/dialogs/add-document-tag/add-document-tag.component';
import { DocumentMetadata, MetadataType } from 'src/app/models/documentMetadata';
import { Tag } from 'src/app/models/tag';
import { DocumentService } from 'src/app/services/document.service';


@Component({
  selector: 'app-document-tags',
  templateUrl: './document-tags.component.html',
  styleUrl: './document-tags.component.scss'
})
export class DocumentTagsComponent {
  @Input() id?: string;
  @Input() title: boolean = true;
  limit: number = 3;

  tags: Tag[] = [];

  constructor(
    private dialog: MatDialog,
    private documentService: DocumentService,
    private translate: TranslateService,
    private toastr: ToastrService
  ) {

  }

  ngOnInit(): void {
    this.retrieveTags();
  }

  async retrieveTags() {
    try {
      if (this.id) {
        this.tags = await this.documentService.retrieveTags(this.id);
      }
    } catch (err) {
      console.log(err)
    }
  }

  async addTags() {
    const config: MatDialogConfig = {
      panelClass: 'dialog-container',
      width: '480px',
      data: {
        tags: this.tags
      }
    }
    const dialog = this.dialog.open(AddDocumentTagComponent, config);
    const result: { added: boolean, tags: Tag[] } = await firstValueFrom(dialog.afterClosed());
    if (result && result.added && result.tags && result.tags.length > 0 && this.id) {
      try {
        this.tags = await this.documentService.addTags(this.id, result.tags.map(tag => tag._id!));
        this.toastr.success(this.translate.instant('DOCUMENT.ADD_TAGS_SUCCESS', { count: result.tags.length }))
      } catch (err) {
        this.toastr.error('ERRORS.GENERIC');
      }
    }
  }

  async deleteTag(tag: Tag) {

    try {
      if (this.id && tag && tag._id) {
        await this.documentService.removeTag(this.id, tag._id);
        this.toastr.success(this.translate.instant('DOCUMENT.REMOVE_TAG_SUCCESS', tag));
        this.retrieveTags();
      }

    } catch (err) {
      this.toastr.error('ERRORS.GENERIC');
    }
  }

  toggle() {
    if (this.limit === 3) {
      this.limit = this.tags.length;
    } else {
      this.limit = 3;
    }
  }

}
